<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         class="ui-queues-page-grid">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="main">
            <ng-template>
                <button [uiAuthorize]="'Queues.Create'"
                        [matTooltip]="'grid_action_add' | translate"
                        [uiClickTrack]="'Action: Add Queue'"
                        [routerLink]="['add']"
                        mat-mini-fab
                        color="primary"
                        data-cy="queue-add"
                        type="button">
                    <mat-icon>add</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorize]="'Queues.Delete'"
                        [matTooltip]="'queues_grid_action_remove' | translate"
                        [disableIf]="loading$ | async"
                        (click)="removeItems()"
                        mat-icon-button
                        color="warn"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete20px"></mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>
    <ui-grid-column [title]="'queues_grid_name' | translate"
                    [sortable]="true"
                    [searchable]="true"
                    [primary]="true"
                    sort="asc"
                    property="name"
                    width="20%">

    </ui-grid-column>
    <ui-grid-column [title]="'queues_grid_description' | translate"
                    [sortable]="true"
                    [searchable]="true"
                    [primary]="true"
                    property="description"
                    width="10%">
    </ui-grid-column>
    <ui-grid-column [title]="'queues_grid_in_progress' | translate"
                    [sortable]="false"
                    property="itemsInProgress"
                    width="7%">
    </ui-grid-column>
    <ui-grid-column [title]="'queues_grid_remaining' | translate"
                    [sortable]="false"
                    property="itemsToProcess"
                    width="7%">
    </ui-grid-column>
    <ui-grid-column [title]="'queues_grid_average_time' | translate"
                    [sortable]="true"
                    property="avgTime"
                    width="15%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-secondformat #secondFormat
                             [matTooltip]="secondFormat.innerText"
                             [seconds]="!entry.avgTime ? 0 : entry.avgTime.toFixed(2)">
            </ui-secondformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [title]="'queues_grid_successful' | translate"
                    [sortable]="true"
                    width="9%"
                    property="successfulTransactions">
    </ui-grid-column>
    <ui-grid-column [title]="'queues_grid_application expections' | translate"
                    [sortable]="true"
                    [primary]="true"
                    property="applicationExceptions"
                    width="9%">
    </ui-grid-column>
    <ui-grid-column [title]="'queues_grid_business_exceptions' | translate"
                    [sortable]="true"
                    [primary]="true"
                    property="businessExceptions"
                    width="9%">
    </ui-grid-column>
    <ui-grid-column [title]="'queues_grid_process' | translate"
                    [sortable]="true"
                    property="processName"
                    width="14%">
        <ng-template let-entry="data">
            <ng-container *ngIf="isCurrentFolderClassic$ | async">
                <mat-icon *ngIf="entry.triggerId"
                          [matTooltip]="'queue_has_trigger' | translate"
                          [svgIcon]="'uipath:triggers'">
                </mat-icon>
                <mat-icon *ngIf="!entry.triggerId"
                          [matTooltip]="'queue_has_no_trigger' | translate"
                          [svgIcon]="'uipath:triggers'"
                          class="disabled">
                </mat-icon>
            </ng-container>
            <span [matTooltip]="entry.processName">{{ entry.processName }}</span>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column *ngIf="isCurrentFolderClassic$ | async"
                    [title]="'queues_grid_has_trigger' | translate"
                    [sortable]="false"
                    [visible]="false"
                    property="triggerId"
                    width="5%">
        <ui-grid-dropdown-filter [items]="hasTriggerList"></ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [uiAuthorizeAnyDisable]="[
                        'Monitoring.View',
                        'Transactions.View',
                        'Transactions.Create',
                        'Queues.Edit',
                        'Queues.Delete'
                    ]"
                    [matMenuTriggerFor]="menu"
                    [matTooltip]="'global_more_actions_tooltip' | translate"
                    mat-icon-button
                    data-cy="grid-action-menu"
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button [uiAuthorize]="'Queues.Edit'"
                        [uiClickTrack]="'Action: Grid: Edit'"
                        [routerLink]="[entry.id, 'edit']"
                        mat-menu-item
                        data-cy="queue-edit"
                        type="button">
                    <mat-icon svgIcon="uipath:Edit"></mat-icon>
                    <span translate="">queues_grid_action_edit</span>
                </button>
                <ng-container *ngIf="isCurrentFolderClassic$ | async">
                    <button *ngIf="entry.triggerId; else createTrigger"
                            [uiAuthorizeAllDisable]="['Schedules.View', 'Schedules.Edit', 'Processes.View']"
                            [uiClickTrack]="'Action: Grid: Edit Queue Trigger'"
                            [routerLink]="['/triggers', entry.triggerId, 'edit']"
                            mat-menu-item
                            data-cy="queue-edit-trigger"
                            type="button">
                        <mat-icon svgIcon="uipath:queueTrigger"></mat-icon>
                        <span translate="">queues_grid_edit_trigger</span>
                    </button>
                    <ng-template #createTrigger>
                        <button [uiAuthorizeAllDisable]="['Schedules.View', 'Schedules.Create', 'Processes.View']"
                                [uiClickTrack]="'Action: Grid: Add Queue Trigger'"
                                [routerLink]="['/triggers','add']"
                                [queryParams]="getQueueTriggerParams(entry)"
                                mat-menu-item
                                data-cy="queue-add-trigger"
                                type="button">
                            <mat-icon svgIcon="uipath:queueTrigger"></mat-icon>
                            <span translate="">queues_grid_add_trigger</span>
                        </button>
                    </ng-template>
                </ng-container>
                <button [routerLink]="[entry.id, 'transactions']"
                        [uiAuthorize]="'Transactions.View'"
                        mat-menu-item
                        data-cy="queue-view-transactions"
                        type="button">
                    <mat-icon svgIcon="uipath:ViewLogs"></mat-icon>
                    <span translate="">queues_grid_action_view_transactions</span>
                </button>
                <button [disableIf]="!isMonitoringEnabled"
                        [routerLink]="['/monitoring/queues/', entry.id]"
                        [uiAuthorize]="'Monitoring.View'"
                        [uiClickTrack]="'Action: Grid: Monitor Queue'"
                        mat-menu-item
                        data-cy="queue-monitor"
                        type="button">
                    <mat-icon>insert_chart</mat-icon>
                    <span translate>queues_grid_action_monitor</span>
                </button>
                <button [uiAuthorize]="'Transactions.View'"
                        [uiClickTrack]="'Action: Grid: View Chart'"
                        (click)="viewChart(entry)"
                        mat-menu-item
                        data-cy="queue-view-chart"
                        type="button">
                    <mat-icon svgIcon="uipath:QueueCharts"></mat-icon>
                    <span translate="">queues_grid_action_view_chart</span>
                </button>
                <button [uiAuthorize]="'Transactions.Create'"
                        [uiClickTrack]="'Action: Grid: Bulk Add'"
                        (click)="onBulkAdd(entry)"
                        mat-menu-item
                        data-cy="queue-bulk-add"
                        type="button">
                    <mat-icon>cloud_upload</mat-icon>
                    <span translate>queues_grid_action_bulk_add</span>
                </button>
                <button [uiAuthorize]="'Queues.Delete'"
                        [disableIf]="loading$ | async"
                        [uiClickTrack]="'Action: Grid: Remove'"
                        (click)="removeItems([entry])"
                        mat-menu-item
                        color="warn"
                        data-cy="queue-remove"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete"></mat-icon>
                    <span translate>queues_grid_action_remove</span>
                </button>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
